import { memo } from "react";
import { useTranslation } from "react-i18next";
import { useSortableData } from "../../app/hooks/useSortableData";

const TableAppComponent = ({ data = [], cols = [], onSelectRow, rowIsActive }) => {
  const { t } = useTranslation();
  const { items, requestSort, sortConfig } = useSortableData(data);
  //const [rowIsActive, setRowIsActive] = useState(null);

  // Filtrar solo las columnas que se deben mostrar en la tabla
  const visibleColumns = cols.filter(col => col.showTable);
  
  // Componente auxiliar para los iconos de ordenamiento
  const SortIcon = ({ accessor, sortConfig }) => {
    // Si no se está ordenando por esta columna, mostrar icono neutro
    if (accessor !== sortConfig?.key) {
      return <i className="fa fa-fw fa-sort table-icon-color-sort-no" style={{ marginLeft: '5px' }} />;
    }

    // Icono según la dirección
    const iconClass = sortConfig.direction === "ascending"
      ? "fa-sort-down table-icon-color-sort"
      : "fa-sort-up table-icon-color-sort";

    return <i className={`fa fa-fw ${iconClass}`} style={{ marginLeft: '5px' }} />;
  };

  return (
    <div className="table-responsive-xxl" style={{ height: "600px", overflow: "auto" }}>
      <table className="table">
        <thead className="table-light">
          <tr>
            {visibleColumns.map((col) => (
              <th
                key={col.id}
                style={{
                  width: col.width || 'auto',
                  whiteSpace: 'nowrap', // Evita que el ID se baje de línea
                  paddingRight: '15px'  // Espacio controlado entre ID y Nombre
                }}
              >
                {col.sort ? (
                  <button
                    onClick={(e) => {
                      e.preventDefault();  // <--- 2. Asegura que no dispare acciones por defecto
                      e.stopPropagation(); // <--- 3. Evita que el clic afecte a otros elementos
                      requestSort(col.accessor);
                  }}
                    style={{ backgroundColor: "transparent", border: "none", padding: 0, fontWeight: 'bold' }}
                  >
                    {t(col.i18nKey || col.header)}
                    <SortIcon accessor={col.accessor} sortConfig={sortConfig} />
                  </button>
                ) : (
                  t(col.i18nKey || col.header)
                )}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="tbody-click">
          {items.length > 0 ? (
            items.map((row) => (
              <tr
                key={row.id}
                onClick={() => onSelectRow(row)}
                className={row.id === rowIsActive ? 'active-row' : ''}
              >
                {visibleColumns.map((col) => (
                  <td
                    key={`${row.id}-${col.id}`}
                    style={{
                      width: col.width || 'auto',
                      whiteSpace: 'nowrap'
                    }}
                  >
                    {row[col.accessor]}
                  </td>
                ))}
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={visibleColumns.length} className="text-center">
                {t("table.loading")}
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default memo(TableAppComponent);
